import { Endpoints } from "../lib/endpoints";
import { PerformRequest } from "../lib/usePerformRequest";
import { PaginatedResponse, NonPaginatedResponse } from "../lib/types";
import { ISubscriber, IEmailHistory } from "../lib/types/Newsletter";

export const getSubscribers = async (page: number, limit: number) => {
  const endpoint = Endpoints.GetSubscribersList(page, limit);
  const result = await PerformRequest<PaginatedResponse<ISubscriber[]>>({
    method: endpoint.method as any,
    route: endpoint.route,
  });

  if (result.status === 200) {
    return result.data;
  }
  throw new Error(result.message || "Failed to fetch subscribers");
};

export const broadcastNewsletter = async (data: { subject: string; content: string }) => {
  const endpoint = Endpoints.BroadcastNewsletter();
  const result = await PerformRequest<NonPaginatedResponse<any>>({
    method: endpoint.method as any,
    route: endpoint.route,
    data,
  });

  return result;
};

export const getSentEmails = async (page: number, limit: number) => {
  const endpoint = Endpoints.GetSentEmailsList(page, limit);
  const result = await PerformRequest<PaginatedResponse<IEmailHistory[]>>({
    method: endpoint.method as any,
    route: endpoint.route,
  });

  if (result.status === 200) {
    return result.data;
  }
  throw new Error(result.message || "Failed to fetch email history");
};
